<template>
    <div class="row">
        <div class="col-12">
            <label v-if="title" :for="`input${id}`">{{title}}</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i :class="`${icon} fa-fw`"></i>
                    </span>
                </div>
                <select
                    v-if="type == 'select'"
                    class="custom-select"
                    :id="`input${id}`"
                    :name="name"
                    ref="select"
                    :required="required"
                    :readonly="readonly"
                    :disabled="disabled"
                    v-model="selected"
                    @change="changeAction"
                >
                    <option value disabled>Selecione</option>
                    <option v-if="enableAll" value="*">Todos</option>
                    <option :key="x.id" v-for="x in listData" v-bind:value="x.id">{{x.name}}</option>
                </select>

                <input
                    v-if="type == 'datalist'"
                    :id="'input' + id"
                    :list="'list' + id"
                    :name="name"
                    value
                    class="custom-select"
                    autocomplete="off"
                    :required="required"
                    :disabled="disabled"
                    :readonly="readonly"
                />
                <datalist v-if="type == 'datalist'" :id="'list' + id">
                    <option :key="x.id" v-for="x in listData" v-bind:value="x.id">{{x.name}}</option>
                </datalist>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        name: String,
        id: String,
        icon: String,
        dataType: String,
        type: {
            type: String,
            default: "select"
        },
        required: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        values: {
            type: Array,
            default: null
        },
        enableAll: {
            type: Boolean,
            default: true
        }
    },
    data: function() {
        return {
            listData: [],
            url: window.location.pathname,
            selected: null
        };
    },
    created() {
        this.popData();
    },
    methods: {
        changeAction() {
            if (this.dataType == "myDepartments") {
                const currentForm = event.target.value;
                localStorage.setItem("currentForm", currentForm);
                this.setCookie("currentForm", currentForm, 365);
                window.location.reload(true);
            }
		},

		setCookie(name, value, days){
			var expires = "";
			if (days) {
				var date = new Date();
				date.setTime(date.getTime() + (days*24*60*60*1000));
				expires = "; expires=" + date.toUTCString();
			}
			document.cookie = name + "=" + (value || "")  + expires + "; path=/";
		},

        popData() {
            var self = this;
            switch (this.dataType) {
                case "usersList":
                    axios
                        .get(self.url + "/userList")
                        .then(function(response) {
                            self.listData = response.data;
                        })
                        .catch(function(error) {
                            console.error(error);
                        });
                    break;

                case "departments":
                    axios
                        .get(self.url + "/listDepartments")
                        .then(function(response) {
                            self.listData = response.data;
                        })
                        .catch(function(error) {
                            console.error(error);
                        });
                    break;

                case "myDepartments":
                    const selectedDepartment = localStorage.getItem(
                        "currentForm"
                    );
                    self.listData = user.getDepartmentName().map(department => {
                        selectedDepartment == department
                            ? (self.selected = department)
                            : null;
                        return { id: department, name: department };
                    });
                    break;

                case "occurrenceStatus":
                    axios
                        .get("occurrence/status")
                        .then(function(response) {
                            self.listData = response.data;
                        })
                        .catch(function(error) {
                            console.error(error);
                        });
                    break;

                default:
                    self.listData = this.values;
                    break;
            }
        }
    },
    mounted() {
        if (this.dataType == "myDepartments") {
            if (
                !user
                    .getDepartmentName()
                    .includes(localStorage.getItem("currentForm"))
            ) {
                const currentForm = user.getDepartmentName()[0];
                localStorage.setItem("currentForm", currentForm);
                this.setCookie("currentForm", currentForm, 365);
            }
            if (localStorage.hasOwnProperty("currentForm")) {
                const currentForm = localStorage.getItem("currentForm");
                this.setCookie("currentForm", currentForm, 365);
            } else {
                const currentForm = user.getDepartmentName()[0];
                localStorage.setItem("currentForm", currentForm);
                this.setCookie("currentForm", currentForm, 365);
            }
        }
    }
};
</script>
